import { createBrowserHistory } from 'history'

export default createBrowserHistory()

/**
 * It does the history.push from react-router-dom, but with an extra prop,
 * refreshIfNeeded, which does a location.reload()
 * if the to and the current location.hash is equal.
 * @param h The history obj (hook) (becuase we cannot use a React hook inside a callback!)
 * @param to target path (hash) and query
 * @param refreshIfNeeded if the hash is equal to current location.hash,
 * it'll refresh the page
 * @returns nothing
 */
export const goto = (
  h: any, to: string | undefined,
  refreshIfNeeded: boolean = false
): void => {
  if (to == undefined) return

  // This will do the reload if the hashes are equal
  if (refreshIfNeeded &&
    window.location.hash.startsWith('#' + to.split('?')[0])) {
    setTimeout(() => {
      window.location.reload()
    }, 0)
  }

  h.push(to)
}
